import {
  DoRequestResponse,
  getEndpointUrl,
  GlobalActions,
  GlobalPut,
  HTTP_METHOD,
} from '@ps20-frontend/shop-integration-redux';
import { call, put, select, take, takeEvery } from 'redux-saga/effects';
import { App } from '@ps20-frontend/frontend-models';
import { AuthFeResponse } from '@ps20/bff-models';
import { AxiosError } from 'axios';
import { safeSaga } from '@ps20-frontend/safe-saga';
import {
  isApigeeActiveAndNotPermasession,
  isSdwSession,
} from '../selectors/transientState.selector';
import { IAppState } from '../localStore';

export enum AUTHENTICATION_REQUEST_EVENTS {
  AUTHENTICATION_SUCCESSFUL_JWT = 'AUTHENTICATION_SUCCESSFUL_JWT',
  AUTHENTICATION_FAILED = 'AUTHENTICATION_REQUEST_FAILED',
}

export enum SDW_REDIRECT_REQUEST_EVENTS {
  SDW_REDIRECT_SUCCESSFUL = 'SDW_REDIRECT_SUCCESSFUL',
  SDW_REDIRECT_FAILED = 'SDW_REDIRECT_FAILED',
}

export function* watchAuthenticationRequested() {
  yield takeEvery(GlobalActions.SHOP_INIT, safeSaga(authenticationRequested, App.SHOP));
  yield takeEvery(
    AUTHENTICATION_REQUEST_EVENTS.AUTHENTICATION_SUCCESSFUL_JWT,
    safeSaga(successCallback, App.SHOP),
  );
  yield takeEvery(
    AUTHENTICATION_REQUEST_EVENTS.AUTHENTICATION_FAILED,
    safeSaga(errorCallback, App.SHOP),
  );
}

export function* authenticationRequested() {
  const state: IAppState = yield select();
  if (
    (isSdwSession(state) || isApigeeActiveAndNotPermasession(state)) &&
    state.transientState.datenhaltung.sdw.accessToken === null
  ) {
    yield take(GlobalActions.SET_ACCESS_TOKEN);
  }
  yield put(
    new GlobalActions().doRequest({
      appId: App.SHOP,
      url: getEndpointUrl(
        isSdwSession(state) || isApigeeActiveAndNotPermasession(state),
        '/privatschutz/api/authenticate',
      ),
      successEvent: AUTHENTICATION_REQUEST_EVENTS.AUTHENTICATION_SUCCESSFUL_JWT,
      errorEvent: AUTHENTICATION_REQUEST_EVENTS.AUTHENTICATION_FAILED,
      method: HTTP_METHOD.GET,
    }),
  );
}

export function* successCallback(successAction: DoRequestResponse<AuthFeResponse>) {
  const role = successAction.payload.role;
  const globalPut = GlobalPut.getInstance();
  const isAnonToken = successAction.payload.anonym;
  yield call(globalPut.put, new GlobalActions().authenticationSuccessful({ role, isAnonToken }));
  yield take(GlobalActions.LOGGER_INITIALIZED);
  yield call(globalPut.put, new GlobalActions().roleDetermined(role));
}

export function* errorCallback(error: DoRequestResponse<AxiosError>) {
  yield put(
    new GlobalActions().authenticationFailed('authenticationFailed ' + error.payload.message),
  );
  if (error.payload.response.status === 400) {
    yield put(new GlobalActions().errorPageWithCustomContentRequested('failedLogin'));
  } else {
    yield put(new GlobalActions().errorPageRequested());
  }
}
